import React, { useState } from 'react';

const CHAT_API = 'https://chat.prijutnadejda.ru/api';
const ADMIN_API = 'https://zhylytaban.kz/admin/api';
const SYSTEM_KEY = 'shelter_chat_sync_2026';

const MP_ICONS = {
  ozon: '/mp-icons/ozon.webp',
  wb:   '/mp-icons/wb.png',
  ym:   '/mp-icons/ym.png',
};
const MP_LABELS = { ozon: 'Ozon', wb: 'WB', ym: 'ЯМ', unknown: '?' };
const MP_COLORS = { ozon: '#005bff', wb: '#cb11ab', ym: '#cc8800', unknown: '#888' };
const MP_BG    = { ozon: '#e8efff', wb: '#fce8f9', ym: '#fff9db', unknown: '#f5f5f5' };

function moscowDateStr(date) {
  const d = new Date(date.getTime() + 3 * 60 * 60 * 1000);
  return d.toISOString().slice(0, 10);
}

function formatMoscowTime(date) {
  return date.toLocaleString('ru', {
    hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow',
  });
}

export default function MarketplaceCodeMessage({ message }) {
  const [hidden, setHidden] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const [requesting, setRequesting] = useState(false);
  const [requested, setRequested] = useState(false);

  let data = {};
  try { data = JSON.parse(message.content); } catch(e) {}

  const { marketplace = 'unknown', code, sender_name, image_url, db_id, raw_text, tg_date } = data;

  const sentAt = tg_date ? new Date(tg_date) : (message.createdAt ? new Date(message.createdAt) : null);
  const today = moscowDateStr(new Date());
  const isExpired = sentAt ? moscowDateStr(sentAt) < today : false;
  const sentTime = sentAt ? formatMoscowTime(sentAt) : null;

  const label = MP_LABELS[marketplace] || marketplace;
  const color = MP_COLORS[marketplace] || '#888';
  const bg    = MP_BG[marketplace] || '#f5f5f5';
  const icon  = MP_ICONS[marketplace];

  async function hideMessage(markReceived = false) {
    setLoading(true);
    if (db_id) {
      try {
        const endpoint = markReceived ? 'receive' : 'hide';
        await fetch(`${ADMIN_API}/marketplace-codes/${db_id}/${endpoint}`, {
          method: 'POST',
          headers: { 'X-System-Key': SYSTEM_KEY }
        });
      } catch(e) {}
    }
    try {
      await fetch(`${CHAT_API}/marketplace/hide/${message.id}`, {
        method: 'POST',
        headers: { 'X-System-Key': SYSTEM_KEY }
      });
    } catch(e) {}
    setHidden(true);
    setLoading(false);
  }

  async function requestNewCode() {
    if (!db_id || requested || requesting) return;
    setRequesting(true);
    try {
      await fetch(`${ADMIN_API}/marketplace-codes/${db_id}/request-code`, {
        method: 'POST',
        headers: { 'X-System-Key': SYSTEM_KEY }
      });
      setRequested(true);
    } catch(e) {}
    setRequesting(false);
  }

  if (hidden) return null;

  return (
    <>
      <div style={{
        background: isExpired ? '#fff5f5' : '#fff',
        border: `1px solid ${isExpired ? '#ffaaaa' : color + '44'}`,
        borderLeft: `4px solid ${isExpired ? '#e53935' : color}`,
        borderRadius: 8,
        padding: '10px 14px',
        margin: '4px 0',
        maxWidth: 'min(380px, 100%)',
      }}>
        {/* Шапка */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {icon ? (
              <img src={icon} alt={label} style={{ width: 28, height: 28, borderRadius: 6, objectFit: 'cover' }} />
            ) : (
              <span style={{
                background: bg, color, fontWeight: 700, fontSize: 12,
                padding: '2px 8px', borderRadius: 4,
              }}>{label}</span>
            )}
            <span style={{ fontSize: 12, color: '#888' }}>{sender_name}</span>
            {sentTime && (
              <span style={{ fontSize: 11, color: isExpired ? '#e53935' : '#bbb' }}>
                · {sentTime} МСК{isExpired ? ' · просрочен' : ''}
              </span>
            )}
          </div>
          <button onClick={() => hideMessage(false)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 16, color: '#ccc', lineHeight: 1, padding: '0 2px',
          }}>✕</button>
        </div>

        {/* Картинка-скриншот */}
        {image_url && (
          <div onClick={() => setFullscreen(true)} style={{ cursor: 'pointer', marginBottom: 8 }}>
            <img
              src={image_url}
              alt="скриншот"
              style={{
                width: '100%', maxHeight: 180, objectFit: 'contain',
                borderRadius: 6, background: '#f5f5f5',
              }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: 2 }}>
              Нажмите для сканирования
            </div>
          </div>
        )}

        {/* Код */}
        {code && (
          <div style={{
            fontSize: 32, fontWeight: 800, letterSpacing: 3,
            color: isExpired ? '#c62828' : '#111',
            fontFamily: 'monospace', margin: '4px 0 8px', wordBreak: 'break-all',
          }}>
            {code}
          </div>
        )}

        {/* Текст сообщения */}
        {raw_text && (
          <div style={{
            fontSize: 12, color: '#888', background: '#f9f9f9',
            borderRadius: 4, padding: '5px 8px', margin: '4px 0 8px',
            whiteSpace: 'pre-wrap', wordBreak: 'break-word',
          }}>{raw_text}</div>
        )}

        {/* Кнопки */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {isExpired ? (
            <>
              <button
                onClick={requestNewCode}
                disabled={requesting || requested}
                style={{
                  flex: 1, padding: '6px 0', fontSize: 13, borderRadius: 6,
                  border: 'none',
                  background: requested ? '#aaa' : '#e53935',
                  color: '#fff', fontWeight: 600, cursor: requested ? 'default' : 'pointer',
                  minWidth: 140,
                }}
              >{requested ? '✓ Запрос отправлен' : requesting ? '...' : '↺ Запросить новый код'}</button>
              <button
                onClick={() => setFullscreen(true)}
                style={{
                  padding: '6px 10px', fontSize: 13, borderRadius: 6,
                  border: `1px solid #e53935`, background: '#fff5f5', color: '#e53935',
                  fontWeight: 600, cursor: 'pointer',
                }}
              >⛶</button>
            </>
          ) : (
            <>
              <button
                onClick={() => setFullscreen(true)}
                style={{
                  flex: 1, padding: '6px 0', fontSize: 13, borderRadius: 6,
                  border: `1px solid ${color}`, background: bg, color,
                  fontWeight: 600, cursor: 'pointer',
                }}
              >⛶ Полный экран</button>
              <button
                onClick={() => hideMessage(true)}
                disabled={loading}
                style={{
                  flex: 1, padding: '6px 0', fontSize: 13, borderRadius: 6,
                  border: 'none', background: '#4caf50', color: '#fff',
                  fontWeight: 600, cursor: 'pointer',
                }}
              >✓ Использован</button>
            </>
          )}
        </div>
      </div>

      {/* Полноэкранный режим */}
      {fullscreen && (
        <div
          onClick={() => setFullscreen(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: '#000',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
          }}
        >
          {icon && (
            <img src={icon} alt={label} style={{ width: 48, height: 48, borderRadius: 10, marginBottom: 16 }} />
          )}
          {image_url ? (
            <img
              src={image_url}
              alt="скриншот"
              style={{ maxWidth: '100vw', maxHeight: '75vh', objectFit: 'contain' }}
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <div style={{
              fontSize: 72, fontWeight: 900, letterSpacing: 8,
              color: '#fff', fontFamily: 'monospace',
              wordBreak: 'break-all', textAlign: 'center', padding: '0 20px',
            }}>
              {code}
            </div>
          )}
          {code && image_url && (
            <div style={{
              fontSize: 36, fontWeight: 800, letterSpacing: 4,
              color: '#fff', fontFamily: 'monospace', marginTop: 20,
            }}>
              {code}
            </div>
          )}
          <div style={{ fontSize: 13, color: '#444', marginTop: 24 }}>
            Нажмите чтобы закрыть
          </div>
        </div>
      )}
    </>
  );
}
